<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/partner/partnerManage')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 整体表单  -->
    <el-form ref="form" :model="form" label-width="120px">
      <div class="color4272ea fw-600">合伙人信息</div>
      <el-form-item
        label="合伙人姓名"
        prop="userName"
        :rules="[
          {
            required: true,
            message: '请输入合伙人姓名',
            trigger: 'blur'
          }
        ]"
      >
        <el-input
          v-model="form.userName"
          placeholder="请输入合伙人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="合伙人电话"
        prop="userPhone"
        :rules="[{ required: true, validator: phone, trigger: 'blur' }]"
      >
        <el-input
          v-model="form.userPhone"
          placeholder="请输入合伙人电话"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="维护人员"
        prop="staffId"
        :rules="[
          {
            required: true,
            message: '请选择维护人员',
            trigger: 'blur'
          }
        ]"
      >
        <el-select
          v-model="form.staffId"
          placeholder="请选择维护人员"
          @change="changeStaff"
        >
          <el-option
            v-for="(v, i) in people"
            :key="i"
            :label="v.name"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份证号码" prop="identityCard">
        <el-input
          v-model="form.identityCard"
          placeholder="请输入身份证号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="particularDesc">
        <el-input
          placeholder="请输入"
          type="textarea"
          v-model="form.particularDesc"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="照片">
        <el-upload
          ref="upload"
          action="#"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :on-change="handleEditChange"
          :file-list="imgList"
          :http-request="uploadFile"
          :limit="3"
          :accept="'image/*'"
          :auto-upload="true"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="imgsVisible">
          <img width="100%" :src="form.photoDesc" alt="" />
        </el-dialog>
      </el-form-item>
      <div class="color4272ea fw-600">合伙人奖励提现</div>
      <el-form-item label="提现方式" prop="awardWay">
        <el-radio-group v-model="form.awardWay">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">现金提现</el-radio>
          <el-radio :label="2">水卡兑换</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="color4272ea fw-600">分润信息</div>
      <el-form-item label="分润方式">
        <div>合伙人充值分润</div>
      </el-form-item>
      <el-form-item label="维护区域">
        <!-- 分配区域数组 -->
        <el-button
          class="mgl-8"
          @click="
            form.regionBeanList = [partnerRegion()];
            $forceUpdate();
          "
          v-if="form.regionBeanList.length === 0"
          >添加分区
        </el-button>
        <div
          v-for="(v, i) in form.regionBeanList"
          :key="i"
          style="margin-bottom: 20px"
        >
          <div class="flex" style="background: var(--card-bg);padding: 20px 0 0 0">
            <div>
              <el-form-item
                label="区域名称"
                :prop="`regionBeanList.${i}.regionId`"
                :rules="[
                  { required: true, message: '请选择区域', trigger: 'blur' }
                ]"
              >
                <div class="flex aic">
                  <el-select
                    v-model="v.regionId"
                    placeholder="请选择区域"
                    @change="
                      v.regionName = (
                        fenquArr.find(i => i.id === v.regionId) || {}
                      ).regionName
                    "
                  >
                    <el-option
                      v-for="(v, i) in fenquArr"
                      :key="i"
                      :label="v.regionName"
                      :value="v.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="flex aic" v-if="v.regionId">
                  <reginData
                    :regionId="v.regionId"
                    v-model:regionName="v.regionName"
                  >
                    <template #default="{equipment,card,shouyi}">
                      <span class="mgr-15">设备数量：{{ equipment }}台</span>
                      <span class="mgr-15">水卡数量：{{ card }}张</span>
                      <!--                      <span>区域剩余可分配收益：{{ shouyi }}%</span>-->
                    </template>
                  </reginData>
                </div>
              </el-form-item>
              <el-form-item
                label="分润比例"
                :prop="`regionBeanList.${i}.regionRatio`"
                :rules="[
                  {
                    required: true,
                    validator: regionRatioValidator(v),
                    trigger: 'blur'
                  }
                ]"
              >
                <div style="display: flex;flex-direction: column">
                  <div>
                    <el-input-number
                      v-model="v.regionRatio"
                      placeholder="请输入分润比例"
                      :min="0"
                      :max="100"
                      :precision="0"
                      style="width: 160px"
                    >
                    </el-input-number>
                    %
                  </div>
                  <span
                    style="color: rgba(255, 0, 0, 1);
    font-size: 14px;"
                    >注:指订单实付金额的比例</span
                  >
                </div>
              </el-form-item>
              <el-form-item
                label="到期自动回收"
                :prop="`regionBeanList.${i}.autoRecovery`"
                :rules="[
                  { required: true, message: '请选择', trigger: 'blur' }
                ]"
              >
                <el-radio-group
                  v-model="v.autoRecovery"
                  @change="$forceUpdate()"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="v.autoRecovery == 1"
                label="到期时间"
                :prop="`regionBeanList.${i}.recoveryTime`"
                :rules="[
                  { required: true, message: '请选择时间', trigger: 'blur' }
                ]"
              >
                <el-date-picker
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  v-model="v.recoveryTime"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  @input="$forceUpdate()"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div>
              <el-button
                type="text"
                size="small"
                class="mgl-8"
                @click="addDomain"
                v-if="i === form.regionBeanList.length - 1"
                >添加
              </el-button>
              <el-button
                type="text"
                size="small"
                class="mgl-8"
                style="color:var(--danger)"
                @click.prevent="removeDomain(v)"
                >删除
              </el-button>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="维护人分润">
        <!-- 分配区域数组 -->
        <el-button
          class="mgl-8"
          @click="
            form.partnerStaffList = [partnerStaff()];
            $forceUpdate();
          "
          v-if="form.partnerStaffList.length === 0"
          >添加维护人
        </el-button>
        <div
          v-for="(v, i) in form.partnerStaffList"
          :key="i"
          style="margin-bottom: 20px"
        >
          <div class="flex" style="background: var(--card-bg);padding: 20px 0 0 0">
            <div class="flex  flex-w" style="align-items: start">
              <el-form-item
                label="分润人"
                :prop="`partnerStaffList.${i}.afterSalesId`"
                :rules="[
                  { required: true, message: '请选择分润人', trigger: 'blur' }
                ]"
              >
                <div class="flex " style="margin-bottom: 20px">
                  <el-select
                    v-model="v.afterSalesId"
                    placeholder="请选择分润人"
                    @change="
                      v.afterSalesName = (
                        people.find(i => i.id === v.afterSalesId) || {}
                      ).name
                    "
                    style="width: 160px !important"
                  >
                    <el-option
                      v-for="(v, i) in people.filter(
                        item =>
                          !form.partnerStaffList
                            .map(i => i.afterSalesId)
                            .includes(item.id) || item.id === v.afterSalesId
                      )"
                      :key="i"
                      :label="v.name"
                      :value="v.id"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item
                label="分润比例"
                :prop="`partnerStaffList.${i}.sharingProportion`"
                :rules="[
                  {
                    required: true,
                    validator: partnerSharingProportionValidator(v),
                    trigger: 'blur'
                  }
                ]"
              >
                <div style="display: flex;flex-direction: column">
                  <div>
                    <el-input-number
                      v-model="v.sharingProportion"
                      placeholder="请输入分润比例"
                      :min="0"
                      :max="100"
                      :precision="0"
                      style="width: 160px"
                    >
                    </el-input-number>
                    %
                  </div>
                  <span
                    style="color: rgba(255, 0, 0, 1);
    font-size: 14px;"
                    >注:指订单实付金额的比例</span
                  >
                </div>
              </el-form-item>
              <el-form-item
                label="新用户奖励"
                :prop="`partnerStaffList.${i}.newUserRewards`"
              >
                <div style="display: flex;flex-direction: column">
                  <div>
                    <el-input-number
                      v-model="v.newUserRewards"
                      placeholder="请输入新用户奖励"
                      :min="0"
                      style="width: 160px;"
                    >
                    </el-input-number>
                    元
                  </div>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-button
                type="text"
                size="small"
                class="mgl-8"
                @click="addPartnerStaff"
                v-if="i === form.partnerStaffList.length - 1"
                >添加
              </el-button>
              <el-button
                type="text"
                size="small"
                class="mgl-8"
                style="color:var(--danger)"
                @click.prevent="removePartnerStaff(v)"
                >删除
              </el-button>
            </div>
          </div>
        </div>
      </el-form-item>
      <!--      <el-form-item label="分润方式"-->
      <!--        ><span-->
      <!--          >新用户开卡<span style="color:red;"-->
      <!--            >(新用户首次充值后奖励)</span-->
      <!--          ></span-->
      <!--        ></el-form-item-->
      <!--      >-->
      <!--      <el-form-item label="新用户开卡奖励" prop="newUserState">-->
      <!--        <el-radio-group v-model="form.newUserState">-->
      <!--          <el-radio :label="1">开启</el-radio>-->
      <!--          <el-radio :label="0">关闭</el-radio>-->
      <!--        </el-radio-group>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item-->
      <!--        label="奖励金额"-->
      <!--        prop="awardMoney"-->
      <!--        v-if="form.newUserState == 1"-->
      <!--        :rules="[{ required: true, validator: awardMoney, trigger: 'blur' }]"-->
      <!--      >-->
      <!--        <el-input v-model="form.awardMoney" placeholder="请输入奖励金额">-->
      <!--          <template slot="append">元</template>-->
      <!--        </el-input>-->
      <!--      </el-form-item>-->
      <div class="color4272ea fw-600">业绩考核机制</div>
      <el-form-item
        label="业绩考核"
        prop="performanceCheck"
        :rules="[{ required: true, message: '请选择区域', trigger: 'blur' }]"
      >
        <el-radio-group v-model="form.performanceCheck">
          <el-tooltip
            class="item"
            effect="dark"
            content="开启后，合伙人在考核周期内业绩未达标，且满足连续未达标次数时，账号将锁定，无法继续使用[水卡充值]与[水卡绑定]功能，可通过解锁对账号进行恢复。"
            placement="top-start"
          >
            <el-radio :label="1">开启</el-radio>
          </el-tooltip>

          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="充值实付指标"
        prop="rechargeTarget"
        v-if="form.performanceCheck === 1"
        :rules="[{ required: true, validator: assessTo, trigger: 'blur' }]"
      >
        <el-input
          v-model="form.rechargeTarget"
          placeholder="请输入0-9999.9以内数字"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item
        prop="checkPeriod"
        v-if="form.performanceCheck === 1"
        :rules="[{ required: true, validator: assessPeriod, trigger: 'blur' }]"
      >
        <template #label>
          考核周期
          <el-tooltip
            class="item"
            effect="dark"
            content="考核从次日凌晨开始，设置当天纳入第一次考核周期内。"
            placement="top-start"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <el-input v-model="form.checkPeriod" placeholder="请输入1-365以内数字">
          <template slot="append">天</template>
        </el-input>
      </el-form-item>
      <el-form-item
        label="连续未达标次数"
        prop="notQualified"
        v-if="form.performanceCheck === 1"
        :rules="[{ required: true, validator: notAssess, trigger: 'blur' }]"
      >
        <el-input v-model="form.notQualified" placeholder="请输入1-99以内数字">
          <template slot="append">次</template>
        </el-input>
      </el-form-item>
      <!--  -->
      <el-form-item>
        <el-button type="primary" @click="sureSave('form')">保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import {
  handleConfirm,
  handleAlert,
  isHandleConfirm
} from "../../components/UtilsIf";
import { assignObject } from "@/utils/UtilsIf";
import {
  phone,
  identityCard,
  awardMoney,
  regionRatio,
  assessTo,
  assessPeriod,
  notAssess
} from "../../utils/tool";
import reginData from "./components/reginData.vue";
const partnerRegion = (data = {}) => {
  return {
    regionId: null,
    equipment: null,
    card: null,
    shouyi: null,
    regionName: null,
    regionRatio: 0,
    autoRecovery: 0,
    ...data
  };
};
const partnerStaff = (data = {}) => {
  return {
    afterSalesId: null,
    afterSalesName: null,
    newUserRewards: null,
    sharingProportion: 0,
    ...data
  };
};
export default {
  components: {
    breadcrumbs,
    reginData
  },
  data() {
    return {
      partnerRegion,
      partnerStaff,
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 重置为当天 00:00:00
          return time.getTime() <= today.getTime(); // 今天及之前都禁用
        }
      },
      imgsVisible: false,
      imgList: [],
      form: {
        userName: "",
        userPhone: "",
        staffId: "",
        identityCard: "",
        particularDesc: "",
        photoDesc: "",
        // newUserState: 1,
        awardWay: 0,
        // awardMoney: "",
        regionBeanList: [],
        partnerStaffList: [],
        performanceCheck: 0,
        rechargeTarget: "",
        checkPeriod: "",
        notQualified: ""
      },

      addOrEditType: 1,
      fenquArr: [],
      people: [],
      id: null
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
      this.addOrEditType = 2;
    } else {
      this.addOrEditType = 1;
    }
    this.getFenqu();
    this.getPeoplePull();
  },
  methods: {
    phone,
    identityCard,
    awardMoney,
    regionRatio,
    assessTo,
    assessPeriod,
    notAssess,
    changeStaff() {
      if (this.addOrEditType === 1) {
        const result = this.people.find(item => item.id === this.form.staffId);
        if (result) {
          this.form.partnerStaffList = [
            partnerStaff({
              afterSalesId: result.id,
              afterSalesName: result.name
            })
          ];
        }
      }
    },
    regionRatioValidator(v) {
      const remainRegionRatio = this.form.regionBeanList.reduce(
        (acc, curr) => acc + curr.regionRatio,
        0
      );
      return (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入"));
        } else if (remainRegionRatio > 100) {
          callback(new Error("剩余比例不足"));
        } else {
          callback();
        }
      };
    },
    partnerSharingProportionValidator(v) {
      const remainRegionRatio = this.form.partnerStaffList.reduce(
        (acc, curr) => acc + curr.sharingProportion,
        0
      );
      return (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入"));
        } else if (remainRegionRatio > 100) {
          callback(new Error("剩余比例不足"));
        } else {
          callback();
        }
      };
    },
    // 回显--详情
    getDetail() {
      this.$api.partner.partnerDetail({ id: this.id }).then(res => {
        if (res.code === 200) {
          let data = res.data;
          this.form = assignObject(this.form, {
            ...data,
            regionBeanList: data.regionBeanList.map(item => ({
              ...item,
              regionRatio: item.regionRatio ? Number(item.regionRatio) * 100 : 0
            })),
            partnerStaffList: data.partnerStaffList.map(item => ({
              ...item,
              sharingProportion: item.sharingProportion
                ? Number(item.sharingProportion) * 100
                : 0
            }))
          });
          this.imgList = [];
          if (data.photoDesc) {
            (data.photoDesc.split(",") || []).forEach(item => {
              this.imgList.push({ url: item });
            });
          }
        }
      });
    },
    // 分区下拉
    getFenqu() {
      this.$api.marketing.allZonePull().then(res => {
        if (res.code === 200) {
          this.fenquArr = res.data;
        }
      });
    },
    // 新增
    sureSave(d) {
      this.$refs[d].validate(async valid => {
        if (valid) {
          if (this.form.regionBeanList.length == 0) {
            handleAlert("请选择分区", "error");
            return;
          }
          if (this.form.regionBeanList.find(item => item.regionRatio > 5)) {
            const isSure = await isHandleConfirm(
              "当前分润比例较高，请确认是否继续。",
              "warning"
            );
            if (!isSure) return;
          }

          if (this.addOrEditType == 1) {
            handleConfirm("确认新增合伙人吗?", "info")
              .then(() => {
                this.$api.partner
                  .partnerAdd({
                    ...this.form,
                    regionBeanList: this.form.regionBeanList.map(item => ({
                      ...item,
                      regionRatio: item.regionRatio
                        ? Number(item.regionRatio) / 100
                        : 0
                    })),
                    partnerStaffList: this.form.partnerStaffList.map(item => ({
                      ...item,
                      sharingProportion: item.sharingProportion
                        ? Number(item.sharingProportion) / 100
                        : 0
                    }))
                  })
                  .then(res => {
                    if (res.code === 200) {
                      handleAlert("新增成功", "success");
                      this.$router.push("/partner/partnerManage");
                    }
                  });
              })
              .catch(() => {
                return;
              });
          } else {
            handleConfirm("确认保存合伙人吗?", "info")
              .then(() => {
                this.$api.partner
                  .partnerEdit({
                    ...this.form,
                    regionBeanList: this.form.regionBeanList.map(item => ({
                      ...item,
                      regionRatio: item.regionRatio
                        ? Number(item.regionRatio) / 100
                        : 0
                    })),
                    partnerStaffList: this.form.partnerStaffList.map(item => ({
                      ...item,
                      sharingProportion: item.sharingProportion
                        ? Number(item.sharingProportion) / 100
                        : 0
                    })),
                    id: this.id,
                    status: 0
                  })
                  .then(res => {
                    if (res.code === 200) {
                      handleAlert("保存成功", "success");
                      this.$router.push("/partner/partnerManage");
                    }
                  });
              })
              .catch(() => {
                return;
              });
          }
        } else {
          return false;
        }
      });
    },
    getPeoplePull() {
      this.$api.partner.weihuPeoplePull().then(res => {
        if (res.code === 200) {
          this.people = res.data.list;
        }
      });
    },
    // 添加区域
    addDomain() {
      this.form.regionBeanList.push(partnerRegion());
      this.$forceUpdate();
    },
    //合伙人添加维护人分润
    addPartnerStaff() {
      this.form.partnerStaffList.push(partnerStaff());
      this.$forceUpdate();
    },
    // 删除区域
    removeDomain(item) {
      handleConfirm("确认删除该区域吗?", "info")
        .then(() => {
          var index = this.form.regionBeanList.indexOf(item);
          if (index !== -1) {
            this.form.regionBeanList.splice(index, 1);
            this.$forceUpdate();
          }
        })
        .catch(() => {
          return;
        });
    },
    //删除维护人分润
    removePartnerStaff(item) {
      handleConfirm("确认删除该维护人吗?", "info")
        .then(() => {
          var index = this.form.partnerStaffList.indexOf(item);
          if (index !== -1) {
            this.form.partnerStaffList.splice(index, 1);
            this.$forceUpdate();
          }
        })
        .catch(() => {
          return;
        });
    },
    // 照片上传
    // 凭证图片上传------
    handlePictureCardPreview(file) {
      this.form.photoDesc = file.url;
      this.imgsVisible = true;
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        this.$message.error("请上传图片文件（JPG/PNG/GIF等）!");
        return false;
      }
      return true;
    },
    handleRemove(file, fileList) {
      this.imgList = fileList;
      this.form.photoDesc = this.imgList.map(item => item.url).join(",");
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then(res => {
        if (res.code === 200) {
          this.imgList.push({
            url: res.data[0]
          });
          this.form.photoDesc = this.imgList.map(item => item.url).join(",");
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    // 图片超出张数不显示上传框
    handleEditChange(file, fileList) {
      console.log(fileList, "fileList");
      console.log(this.limitCount, "this.limitCount");
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select,
.el-textarea {
  width: 300px !important;
}
</style>
